function scrollToContent(selector) {
    var offset = 0;

    jQuery('html,body').animate({
        scrollTop: jQuery('#' + selector).offset().top - offset
    }, 1500);
}

function initScroller() {
    var pagePositon = -1,
     sectionsSelector = '.scrollto-section',
     $scrollItems = $(sectionsSelector),
     offsetTolerance = 30,
     pageMaxPosition = $scrollItems.length - 1;

    //Map the sections:
    $scrollItems.each(function (index, ele) {
        $(ele).data("pos", index);
    });
}

// Mobile dropdown hover
$(document).ready(function() {
    $('#MyNavbar .menu-item').each(function(){
        if($(this).hasClass('dropdown')){
            $(this).find('.dropdown-toggle').after('<i class="fa fa-angle-down"></i>');
        }
    });
    $('#MyNavbar .menu-item.dropdown i').on('click',function(e){
        if($(this).parent('li').find('a').hasClass('active')){
            $(this).parent('li').find('a').removeClass('active');
            $(this).parent('li').find('a').removeClass('active').attr('data-click-state',0)
            $(this).parent('li').find('a').parent().find('.dropdown-menu').hide();
            $(this).parent('li').removeClass('lt-opened');
        }else{
            $(this).parent('li').find('a').addClass('active');
            $(this).parent('li').find('a').addClass('active').attr('data-click-state',1)
            $(this).parent('li').find('a').parent().find('.dropdown-menu').show();
            $(this).parent('li').addClass('lt-opened');
        }
    })
});

function is_touch_device() {
  return !!('ontouchstart' in window);
}

var isMobile = false; //initiate as false

$(document).ready(function () {

    // device detection
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
        isMobile = true;
    }

    //IE object-fit cover polyfill
    objectFitImages('.fit-cover');

    //scrolling
    $('.js-scroll-slide').click(function() {

        var dir = $(this).data('dir');

        if (dir == 'right') {
            var temp = $(this).parent().find('.js-scrollable').scrollLeft() + ($('.js-scroll-width').outerWidth() + 5);
        } else {
            var temp = $(this).parent().find('.js-scrollable').scrollLeft() - ($('.js-scroll-width').outerWidth() + 5);
        }

        $(this).parent().find('.js-scrollable').animate({
            scrollLeft: temp
        }, 250);

    });


    /** =============================================
     *  COVER SLIDER THINGS - ON SEVERAL PAGES
     *  ============================================= */
    firstSlideIsVideo = false;

    function coverSliderScroll() {
        if ($('.cover-slider .slick-current video').length) {
            if ($(window).scrollTop() > 30) {
                $('.cover-slider .slick-current video')[0].pause();
            } else {
                $('.cover-slider .slick-current video')[0].play();
            }
        }
    }

    function initSlideVideo($video) {
        if ($coverSlider) {
            $coverSlider.slick('slickPause');
        }

        $video[0].play();
        $video.on("ended", function () {
            $('.cover-slider').slick('slickPlay')
        })
    }

    $('.cover-slider').on('init', function (event, slick) {
        var $firstSlide = $(slick.$slides[0]);
        if ($firstSlide.find("video").length) {
            $video = $firstSlide.find("video");
            firstSlideIsVideo = true;
            initSlideVideo($video);
        }
    });

    var $coverSlider = $('.cover-slider').slick({
        dots: true,
        autoplay: true,
        speed: 1200,
        slidesToScroll: 1,
        slidesToShow: 1,
        autoplaySpeed: 3000,
        fade: true,
        arrows: false
    });

    if (!firstSlideIsVideo) {
        $('.cover-slider').slick('slickPlay');
    }


    if ($(".cover-slider").length > 0) {
        //on document ready load the text of the first slide into the cover rectangle and adjust the rectangle's width to it's content text + 30px
        var frontCoverRect = $('.cover .rectangle');
        var frontCoverRectText = $('.cover .rectangle h1');

        if ($('.cover').find("[data-slick-index='0']").find("video").length) {
            frontCoverRect.hide();
        }
        else {
            frontCoverRectText.html($('.cover').find("[data-slick-index='0']").text());
        }
    }

    // On before slide change
    $('.cover-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        //clean the cover rectangle's content
        frontCoverRectText.html("");

        var currentSlideItem = $('.cover').find("[data-slick-index='" + currentSlide + "']");
        if (currentSlideItem.find("video").length) {
            currentSlideItem.find("video")[0].pause()
        }

        //get the text that we need to load in the rectangle, but hide it for now
        var nextSlideItem = $('.cover').find("[data-slick-index='" + nextSlide + "']");
        var nextSlideText = nextSlideItem.text();
        frontCoverRectText.html(nextSlideText);
        frontCoverRect.hide();
    });

    $('.cover-slider').on('afterChange', function (event, slick, currentSlide) {
        //after the slide's been loaded, fade in the rectangle's content
        if (!$coverSlider.slick("slickGetOption", "autoplay")) {
            $coverSlider.slick('slickPlay');
        }
        var $currentSlide = $('.cover').find("[data-slick-index='" + currentSlide + "']");

        if ($currentSlide.find("video").length) {
            initSlideVideo($currentSlide.find("video"));
            return;
        }

        frontCoverRect.fadeIn("slow");
    });

    

    /** =============================================
     *  MASONRY INITIALIZATION ON PARTNER PROGRAM PAGE
     *  ============================================= */

    $('.grid').masonry({
        itemSelector: ".grid-item"
    });

    /** =============================================
     *  SCROLL TO CONTENT ON HASH CHANGE
     *  ============================================= */

    function checkHash() {
        if (window.location.hash) {

            var hash = window.location.hash.substring(2);
            scrollToContent(hash);
        }
    }

    checkHash();

    $(window).on('hashchange', function () {
        checkHash();
    });

    window.scrollToContent = scrollToContent;


    /** =============================================
     *  LAZY LOAD
     *  ============================================= */

    var bLazy = new Blazy();

});

$(document).ready(function() {
    $(document).on('click', '.js-show-cities', function () {
        $(this).addClass('active');
    });

    $('.js-anchor-cat').on('click', function() {
        scrollToContent($(this).data('id'));
    });

    $('.selectric-year').selectric();

    $('.js-year-select').on('change', function() {
        const cat = $(this).data("cat");
        $('.' + cat).find('.js-award-card').hide();
        if ($(this).val() == 'all') {
            $('.' + cat).find('.js-award-card').show();
        } else {
            $('.' + cat).find('.'+ $(this).val()).show();
        }
    })
});

let activeTab = 'tabs-1';

$('.js-option').on('click', function() {
    $('.js-option').removeClass("active");

    $(this).addClass("active");
    activeTab = $(this).attr("id");

    $('.js-selected-content').each(function() {
        if($(this).attr("id") == activeTab) {
            $(this).show();
        }
        else {
            $(this).hide();
        }
    });
});